class FormCaptcha {
	static isNeeded = false;
	static isPassed = false;

	static maybeInit(drForm, submitEvent) {
		FormCaptcha.isNeeded = !!drForm.querySelectorAll('.g-recaptcha').length;
		if (FormCaptcha.isNeeded) {
			let isPassed = drForm.querySelectorAll('.g-recaptcha')[0].dataset['valid'] || "0";
			FormCaptcha.isPassed = isPassed === '1';
			if (!FormCaptcha.isPassed) {
				// bind additional logic for Captcha validation
				FormCaptcha.init(drForm, submitEvent);
			}
		}
	}

	static init(drForm, submitEvent) {
		// prevent sending data to FA before captcha passed
		submitEvent.preventDefault();
		// run invisible captcha
		let ID = drForm.querySelectorAll('.g-recaptcha')[0].id;
		grecaptcha.render(ID, {
			'callback': FormCaptcha.onSuccess.bind(null, submitEvent),
		});
		grecaptcha.execute();
		return false;
	}

	static onSuccess(submitEvent, key) {
		return new Promise(function (resolve, reject) {
			let form = submitEvent.target;
			let drForm = form.closest('.dr-form');
			// Verify that user successfully passed captcha
			if (grecaptcha.getResponse() !== "") {
				// set exact form from context valid to proceed
				drForm.querySelectorAll('.g-recaptcha')[0].dataset.valid = "1";
				// Detect submit button, and resend form data with Valid param
				let button = drForm.getElementsByClassName('primaryAction')[0];
				button.disabled = false;
				button.click();
				resolve();
			}
			// wait until Captcha not passed reset if response error;
			grecaptcha.reset();
		});
	}
}

export default FormCaptcha;
